import { Schema } from "effect";
import { WorktreeResponses } from "../station/worktree.ts";
import { ChatApprovalDecisionResponse, ChatConfigResponse, ChatProposalOutcomeRow, ChatTailResponse, ChatThreadSummary } from "../chat-contract.ts";

/** The success body that each chat endpoint declares, by endpoint name. The
 * HTTP door sends the actor's success only as this body. */
export const ChatSuccess = /* @__PURE__ */ (() => ({
  config: ChatConfigResponse,
  configure: Schema.Struct({ ok: Schema.Literal(true) }),
  threads: Schema.Struct({ threads: Schema.Array(ChatThreadSummary) }),
  createThread: ChatThreadSummary,
  tail: ChatTailResponse,
  message: Schema.Struct({ sequence: Schema.Number }),
  stop: Schema.Struct({ stopping: Schema.Boolean }),
  proposalReview: WorktreeResponses["worktree.diff"],
  proposal: Schema.Struct({ outcome: ChatProposalOutcomeRow.fields.outcome, detail: ChatProposalOutcomeRow.fields.detail }),
  approval: ChatApprovalDecisionResponse
}))();
export type ChatRoute = keyof typeof ChatSuccess;
